<script>
import { approval_options } from '../../utils/config';

export default {
    props: {
        approval_status: {
            type: Object,
            required: true,
        },

        canEdit: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        approvalOptions() {
            return approval_options;
        }
    },

    methods: {
        emit(key) {
            if (this.canEdit) {
                this.$emit('action', key);
            }
        },

        generateEditedByText() {
            const name = this.approval_status.last_edited_by;
            const date = this.$formatDate(this.approval_status.last_edited_on);
            return this.$t('approval.misc.last_updated').replace('#N#', name).replace('#D#', date);
        },
    },
}
</script>

<template>
    <div class="approval-button">
        <div class="flex-all-centered-row" v-if="approval_status && approval_status.status">
            <button v-for="o in approvalOptions" :key="o.key" class="approval-buttons"
                :style="{ 
                    'background-color': (o.key === approval_status.status ? o.bgColor : 'lightgray'), 
                    'cursor': (o.key === approval_status.status || canEdit === false) ? 'default' : null
                }"
                v-sust-tooltip="{ 
                    text: o.key === approval_status.status ? generateEditedByText() : $t(`approval.options.${o.key}`), 
                    fontSize: '.75em' 
                }"
                @click="emit(o.key)"
            >
                <i :class="o.icon"></i>
            </button>
        </div>
        <div class="flex-all-centered-row" v-else>
            <button v-for="o in approvalOptions" :key="o.key" class="approval-buttons"
                :style="{ 
                    'background-color': 'lightgray',
                }"
                v-sust-tooltip="{ 
                    text: $t(`approval.options.${o.key}`), 
                    fontSize: '.75em' 
                }"
                @click="emit(o.key)"
            >
                <i :class="o.icon"></i>
            </button>
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .approval-button {
        font-size: 1.25em;

        > div {
            > button {
                padding: .1em .3em;
                border: 0 !important;
                outline: 0 !important;
                color: whitesmoke;

                transition: filter 150ms;
                &:hover {
                    filter: brightness(105%);
                }

                &:first-of-type {
                    border-bottom-left-radius: .3em;
                    border-top-left-radius: .3em;
                    border-right: thin solid whitesmoke !important;
                }
                
                &:last-of-type {
                    border-bottom-right-radius: .3em;
                    border-top-right-radius: .3em;
                    border-left: thin solid whitesmoke !important;
                }
            }
        }

        > button {
            cursor: default !important;
            background-color: transparent !important;
            color: var(--sustainfinity-navy) !important;
        }
    }
</style>